import { useEffect } from 'react';

const SEO = ({ 
  title = "EvoCore PACA - Intelligence Artificielle pour Auto-Entrepreneurs",
  description = "EvoCore PACA accompagne les auto-entrepreneurs et indépendants de la région Sud dans leur transformation numérique avec l'intelligence artificielle.",
  keywords = "IA, intelligence artificielle, auto-entrepreneurs, PACA, Côte d'Azur, transformation numérique, French Tech",
  ogImage = "/logo512.png",
  url
}) => {
  useEffect(() => {
    const currentUrl = url || (typeof window !== 'undefined' ? window.location.href : 'https://www.evocore-paca.fr/');
    // Update title
    document.title = title;

    // Update meta tags
    const metaTags = {
      'description': description,
      'keywords': keywords,
      'og:title': title,
      'og:description': description,
      'og:url': currentUrl,
      'og:image': ogImage,
      'og:type': 'website',
      'og:site_name': 'EvoCore PACA',
      'twitter:title': title,
      'twitter:description': description,
      'twitter:image': ogImage,
      'twitter:card': 'summary_large_image',
    };

    Object.entries(metaTags).forEach(([name, content]) => {
      let meta = document.querySelector(`meta[name="${name}"]`) || 
                 document.querySelector(`meta[property="${name}"]`);
      
      if (meta) {
        meta.setAttribute('content', content);
      } else {
        meta = document.createElement('meta');
        if (name.startsWith('og:') || name.startsWith('twitter:')) {
          meta.setAttribute('property', name);
        } else {
          meta.setAttribute('name', name);
        }
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
      }
    });

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', currentUrl);
    } else {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      canonical.setAttribute('href', currentUrl);
      document.head.appendChild(canonical);
    }
  }, [title, description, keywords, ogImage, url]);

  return null;
};

export default SEO;
